<template>
  <div>
    <GoogleLogin @success="loginSuc"></GoogleLogin>
  </div>
</template>

<script>
import GoogleLogin from '@/components/social/Google.vue'
import { passportSocialLogin } from '@/api'
import { VerifySM } from '@/utils/SMCaptcha'
import pageHelper from "@/oauthFPX/common/pageHelper";
export default {
  name: 'Google',
  components: { GoogleLogin },
  mixins: [pageHelper],
  methods: {
    loginSuc (userInfo) {
      this.doLoginNext(userInfo)
    },
    doLoginNext (userInfo, verifyData) {
      const params = {
        bind_type: this.$ENUM.SOCIAL_CODE_MAP[userInfo.type],
        social_id: userInfo.id,
        access_token: userInfo.token,
        social_email: userInfo.email,
        social_name: userInfo.name,
        minor_verification: 0,
        device_id: this.$utils.md5Hash(userInfo.id)
      }
      if (verifyData) {
        params.verify_data = verifyData
        params.captcha_channel = 'sm'
      }
      passportSocialLogin(params).then(res => {
        const data = {
          id: res.fp_uid,
          name: res.bind_display_name || res.user_display_name,
          token: res.session_key,
          type: userInfo.type,
          fp_device_id: res.fp_device_id,
          expire: res.session_key_timeout,
        }
        window.localStorage.setItem('deviceId', res.fp_device_id || '')

        const urlParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
        if (urlParams.returnUrl) this.changeInfoToCode(urlParams.returnUrl, { userInfo: res})
        else if (urlParams.oauthtype === this.$ENUM.OAUTH_TYPES.PASSPORT_LOGIN && window.opener) {
          window.opener.postMessage({ type: 'fpOauthLoginPSPT', data: { userInfo: res} }, '*')
        } else {
          this.$router.push({
            name: 'OauthFPXResult',
            params: {
              type: 'success',
              loginData: data
            }
          })
        }
      }).catch(err => {
        if (err.code === 110011) {
          VerifySM(data => {
            if (data.pass) {
              this.doLoginNext(userInfo, data)
            }
          })
        } else {
          this.$msg.success(err.msg)
        }
      })
    }
  }
}
</script>

<style lang='less' scoped >
.login {
  width: 31px;
  height: 31px;
  background: url(~@img/icon_facebook.png) center center no-repeat;
  background-size: 100% 100%;
}

</style>
